














































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import axios, { resHandle } from "@/plugins/axios";
@Component({})
export default class TermMulitiSelect extends Vue {
  @Prop()
  private message: any;
  @Prop()
  private valueKey: any;
  @Prop()
  private nameKey: any;
  @Prop()
  private type: any;
  @Prop()
  private api: any;
  private ifShowAll: boolean = false;
  private ifShowDialog: boolean = false;
  private searchText: string = "";
  private searchResult: any[] = [];
  private hasText: string = "";
  private hasResult: any[] = [];
  private ifSearchedHas: boolean = false;
  private get m() {
    return this.message || [];
  }
  private set m(val) {
    this.$emit("udpate:message", val);
  }
  /**
   * @description 打开编辑弹框
   */
  private openDialog() {
    this.ifShowDialog = true;
    this.searchTerm();
  }
  /**
   * @description 显示全部，不搜索
   */
  private showAll() {
    this.ifShowAll = true;
    this.ifShowDialog = true;
  }
  /**
   * @description 搜索
   */
  private searchTerm() {
    const params: any = {
      search: this.searchText,
    };
    axios.post(this.api, params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.searchResult = data.data;
      });
    });
  }
  /**
   * @description 添加一个选项
   */
  private addTerm(item, index) {
    this.m.push(item);
    this.$emit("update:message", _.uniqBy(this.m, this.valueKey));
    this.ifSearchedHas = false;
    this.hasResult = [];
  }
  /**
   * @description 添加全部
   */
  private selectAll() {
    this.searchResult.forEach((item: any) => {
      this.m.push(item);
    });
    this.$emit("update:message", _.uniqBy(this.m, this.valueKey));
    this.ifSearchedHas = false;
    this.hasResult = [];
  }
  /**
   * @description 搜索已有
   */
  private searchHas() {
    this.hasResult = this.m.filter((item) => {
      return item[this.nameKey].includes(this.hasText);
    });
    this.ifSearchedHas = true;
  }
  /**
   * @description 清空全部已选
   */
  private deleteAll() {
    if (this.ifSearchedHas) {
      this.hasResult.forEach((item: any) => {
        const index = _.findIndex(this.m, (i) => {
          return item[this.valueKey] === i[this.valueKey];
        });
        this.m.splice(index, 1);
      });
      this.ifSearchedHas = false;
    } else {
      this.m.splice(0, this.m.length);
    }
  }
  /**
   * @description 删除某个已选
   */
  private deleteOne(index) {
    this.m.splice(index, 1);
  }
  /**
   * @description 从已经搜索的已选里删除一个
   */
  private deleteOneHas(item) {
    const index = _.findIndex(this.m, (i: any) => {
      return i[this.valueKey] === item[this.valueKey];
    });
    this.m.splice(index, 1);
  }
  /**
   * @description 返回全部已选
   */
  private returnToAllHas() {
    this.hasResult = [];
    this.ifSearchedHas = false;
  }
}
